import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Subject, throwError, Observable } from 'rxjs';
import { defaultConfig } from '../../enums/snackbar-config';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private snackbarSubject = new Subject<{ message: string, config?: MatSnackBarConfig }>();

  snackbarMessage$ = this.snackbarSubject.asObservable();

  constructor(private snackBar: MatSnackBar) {
    this.snackbarMessage$.subscribe(snackBarMessage => {
      this.showSnackBar(snackBarMessage.message, snackBarMessage.config);
    });
  }

  handleApiError(error: any): Observable<never> {
    console.error('An error occurred', error);
    const errorResponse = JSON.stringify(error, null, 4);

    let errorString = 'Något gick fel. Ladda om sidan och kontakta administratör om det fortfarande inte fungerar.';

    if (error.error?.errors) {
      errorString = '';

      for (const property in error.error.errors) {
        if (Object.prototype.hasOwnProperty.call(error.error.errors, property)) {
          errorString += error.error.errors[property] + '\n';
        }
      }
    }
    else if (error.error?.detail) {
      errorString = error.error.detail;
    }

    this.showResponse(errorString);
    return throwError(() => error);
  }

  showResponse(message: string, config?: MatSnackBarConfig): void {
    this.snackbarSubject.next({ message, config });
  }

  private showSnackBar(message: string, config?: MatSnackBarConfig): void {
    const snackBarConfig = { ...defaultConfig, ...config };
    this.snackBar.open(message, 'Stäng', snackBarConfig);
  }
}
